import { aC as a, aO as n } from "./StickyHeaderSkeleton-4367f5a1.mjs";
import { v as o, A as e } from "./Header-1f7fc8dd.mjs";
function u(r) {
  const {
    lang: s
  } = a();
  return o({
    queryKey: [e.CLIENT_V1_COURSE_CATEGORY, {
      lang: s
    }, "GNB_COURSE_CATEGORIES"],
    url: n(e.CLIENT_V1_COURSE_CATEGORY),
    options: {
      ...r,
      suspense: !1,
      cacheTime: 1 / 0,
      staleTime: 1 / 0,
      useErrorBoundary: !1
    }
  });
}
export {
  u
};
